import {
	ASSETS_LOAD_START,
	ASSETS_LOAD_SUCCESS,
	ASSETS_LOAD_FAIL,
} from "../actions/types";

import {
	STATUS_LOADING,
	STATUS_LOADED,
	STATUS_FAILED,
  STATUS_UNINITIALISED,
} from "./status";

const initialState = {
	items: [],
	error: null,
	status: STATUS_UNINITIALISED,
};

export default function assets(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case ASSETS_LOAD_START:
			return {
				...state,
				// items: null,
				error: null,
				status: STATUS_LOADING
			};

		case ASSETS_LOAD_SUCCESS:
			return {
				...state,
				items: payload,
				error: null,
				status: STATUS_LOADED
			};

		case ASSETS_LOAD_FAIL:
			return {
				...state,
				items: null,
				error: payload,
				status: STATUS_FAILED
			};

		default:
			return state;
	}
}